export const ProjectInformationMapping = {
  // ProjectInformation: 0,
  
  projectName: 0,
  projectStartDay: 0,
  projectStatus: 0,
  remarks: 0,
  approvedBy: 0,
  projectDescription: 0,
  ClinetInformation: 1,
  approvalDetails: 2,
};
